import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://apisicol.encodelabs.com.ar/api',
  frontUrl: 'https://sicol.encodelabs.com.ar/',
  version: 'v1.0.0',
  grant_type: 'password',
  client_secret: 'NdQjJZnYzZnOEbmrCtKE1CXiRC9iuYRx',
  client_id: 'scl-api',
  keyCloackAdminUrl: 'http://10.11.10.110:8080/admin/realms/SCL',
  kcUrl:'https://keycloaksicol.encodelabs.com.ar/realms/SCL/protocol/openid-connect',
  cryptoKey: 'sclbo24',
};
